<script>
  import reveal from '../lib/actions/reveal.js';
  import SectionHeader from '../lib/ui/SectionHeader.svelte';
  import parallax from '../lib/actions/parallax.js';
</script>

<section id="nfas" class="section nfas-contrast" aria-label="What are NFAs">
  <div class="container">
    <div class="nfas-bg" aria-hidden="true"></div>
    <div class="nfas-float" use:parallax={{speed:0.15}} aria-hidden="true"></div>

    <div class="center" use:reveal>
      <SectionHeader title="What are NFAs">
        <span slot="desc">
          The NFT era showed us what digital ownership could look like, but static images and collectibles could only go so far.<br><br>
          NFAs take the next step. Built on BAP-578, a new token standard that enables on-chain data storage, memory, and intelligence, NFAs are self-learning, interactive digital beings that can think, act, and grow.<br><br>
          With Lumina, anyone can mint, train, and unleash NFAs into the agentic economy.
        </span>
      </SectionHeader>
    </div>

    <div class="chips" style="margin-top: 22px;">
      <div class="chip" use:reveal>NFT → NFA</div>
      <div class="chip" use:reveal={{delay:80}}>Static → Intelligent</div>
      <div class="chip" use:reveal={{delay:160}}>Collectible → Autonomous</div>
      <div class="chip" use:reveal={{delay:240}}>Dead → Alive</div>
    </div>

    <div class="explain" use:reveal={{delay:180}}>
      <div class="glass explain-card">
        <img src="/media/boredapenftexplainationv4.png" alt="Diagram explaining transition from NFTs to NFAs" />
      </div>
    </div>

    <style>
      .nfas-contrast { position: relative; padding-top: 110px; padding-bottom: 110px; }
      .nfas-bg { position:absolute; inset: 0; pointer-events: none; }
      .nfas-bg::before { content:""; position:absolute; left:50%; top:-10%; transform:translateX(-50%); width:min(1200px, 95vw); height: 280px; border-radius: 50%;
        background: radial-gradient(60% 100% at 50% 20%, rgba(33,243,255,0.16), rgba(0,255,198,0.12), transparent 70%);
        filter: blur(18px); opacity:.7; }
      .nfas-bg::after { content:""; position:absolute; left:50%; bottom:-10%; transform:translateX(-50%); width:min(1200px, 95vw); height: 240px; border-radius: 50%;
        background: radial-gradient(60% 100% at 50% 80%, rgba(124,255,91,0.12), rgba(33,243,255,0.10), transparent 70%);
        filter: blur(18px); opacity:.6; }

      .nfas-float { position:absolute; left:50%; top: 10%; transform: translateX(-50%); width: min(900px, 86vw); height: 180px; border-radius: 50%;
        background: radial-gradient(closest-side, rgba(0,255,198,.12), rgba(33,243,255,.10), transparent 70%);
        filter: blur(16px); opacity:.5; pointer-events:none; }

      .center { text-align: center; max-width: 78ch; margin: 0 auto; }
      .chips { display: grid; grid-template-columns: repeat(2, minmax(220px, 1fr)); gap: 14px; width: min(900px, 92vw); margin-left: auto; margin-right: auto; }
      @media (min-width: 900px) {
        .chips { grid-template-columns: repeat(4, 1fr); }
      }
      .chip { text-align: center; letter-spacing: 1.2px; text-transform: uppercase; font-weight: 700; color: var(--fg);
        border: 1px solid var(--card-border); border-radius: 999px; padding: 12px 16px;
        background: linear-gradient(90deg, rgba(0,255,198,0.08), rgba(33,243,255,0.08));
        box-shadow: 0 0 0 1px rgba(255,255,255,0.02) inset, 0 10px 30px rgba(0,255,198,0.10);
      }

      .explain { display:flex; justify-content:center; margin-top: 26px; }
      .explain-card { width: calc(min(1100px, 96vw) * 0.7); overflow: hidden; border-radius: var(--r-l); }
      .explain-card img { display:block; width:100%; height:auto; }
    </style>
  </div>
</section>
